import { render, staticRenderFns } from "./RequisitionAssignments.vue?vue&type=template&id=7ad1dda8&"
import script from "./RequisitionAssignments.vue?vue&type=script&lang=js&"
export * from "./RequisitionAssignments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports